export const toSpanishDate = (s) => {
    if (!s) return "";
    const [yyyy, mm, dd] = String(s).split("-");
    if (!yyyy || !mm || !dd) return s;
    return `${dd}-${mm}-${yyyy}`;
};
